<template>
    <van-popup v-model="showCcRequest" round position="bottom" :style="{ height: '80%' }">
        <div class="cc">

            <!-- tab栏选择 -->
            <van-tabs color="#1989FA" type="line" v-model="tabActive">
                <van-tab name="0" title="最近">
                </van-tab>
                <van-tab name="1" :title="personType == 'teacher' ? '老师' : '老师'" style="height: 80%;">
                </van-tab>

                <van-tab name="2" title="部门" v-if="personType == 'teacher'">
                </van-tab>
            </van-tabs>
            <!-- 最近请假人数 -->

            <div class="recently" v-if="tabActive == 0">
                <div class="colleague_person_list">
                    <div class="list_con_con">

                        <div class="list_con" v-for="dept in lastDeptList.filter(item => isChildren(item.id))">
                            <van-checkbox v-model="dept.isChecked" @change="testDept($event, dept)"></van-checkbox>
                            <img :src="schoolIcon" />
                            <div class="person_info">
                                <span class="name">
                                    {{ dept.name }}
                                </span>
                                <span class="deptname">
                                    {{ dept.remark }} 人
                                </span>
                            </div>
                        </div>

                        <!-- 最近抄送的老师 -->
                        <div class="list_con" v-for="person in lastPersonList">
                            <van-checkbox v-model="person.isChecked"></van-checkbox>
                            <img :src="person.avatar" />
                            <div class="person_info">
                                <span class="name">
                                    {{ person.name }}
                                </span>
                                <span class="deptname">
                                    {{ person.remark }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <van-empty v-if="lastDeptList.length == 0 && lastPersonList.length == 0" description="暂无最近抄送详情" />
                </div>

                <div class="change_list">
                    <van-checkbox v-model="resetIsChecked" onchange="resetState($event)"
                        style="margin-right: 10px;margin-left: 7px"> </van-checkbox>
                    <span>已选择： </span>
                    <span class="number_span">
                        <span v-if="(nowIsChangeDeptList.length + lastDeptList.filter(item => item.isChecked).length) > 0">
                            {{ nowIsChangeDeptList.filter(item => item.children.length == 0).length +
                                lastDeptList.filter(item => item.isChecked && isChildren(item.id)).length }} 个部门</span>
                        <span v-if="(nowIsChangeList.length + lastPersonList.filter(item => item.isChecked).length) > 0">
                            {{ nowIsChangeList.length + lastPersonList.filter(item => item.isChecked).length }} 位{{
                                personType
                                == 'teacher' ? '老师' : '老师' }}</span>
                    </span>
                    <van-button type="info" size="small" @click="handleChange(1)">完成</van-button>
                </div>
            </div>
            
            <!-- 同事/老师选择 -->
            <div class="colleague" v-if="tabActive == 1">
                <!-- 搜索框 -->

                <div class="colleague_search">
                    <van-search v-model="personKerword" show-action @clear="teacherList = []" shape="round"
                        @search="onSearch" :placeholder="personType == 'teacher' ? '输入老师姓名搜索' : '输入老师姓名搜索'">
                        <template #action>
                            <div class="search_btn" @click="onSearch">搜索</div>
                        </template>
                    </van-search>
                </div>

                <div class="colleague_person_list">
                    <div class="list_con_con">


                        <span v-if="nowIsChangeList.length > 0 || lastPersonList.filter(s => s.isChecked).length > 0"
                            style="margin-left: 12px;font-size: 14px;">
                            已选择
                        </span>



                        <!-- 已选择列表 -->
                        <div style="border-bottom: 1px solid #E5E5E5;" v-if="nowIsChangeList.length > 0 || lastPersonList.filter(s => s.isChecked).length > 0">


                            <div class="list_con" v-for="(item1, index) in [...lastPersonList.filter(s => s.isChecked), ...nowIsChangeList] ">
                           
                                <!-- [...lastPersonList.filter(s => s.isChecked), ...nowIsChangeList] -->

                                <div class="list_deptList" style="width: 100%;" >
                                    <van-checkbox v-model="item1.isChecked" @change="cancelTeacherChange($event,item1)"></van-checkbox>
                                    <img :src="item1.avatar" />
                                    <div class="person_info"
                                        :style="{ 'border-bottom': index == (nowIsChangeList.length + lastPersonList.filter(s => s.isChecked).length) - 1 ? 'none' : '' }">
                                        <span class="name">
                                            {{ item1.name }}
                                        </span>
                                        <span class="deptname">
                                            {{ item1.deptName }}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>




                        <!-- 未选择列表  -->
                        <div class="list_con" v-for="item in teacherList">
                            <div class="list_deptList" style="width: 100%;" v-if="!item.isShow" >
                                <van-checkbox v-model="item.isChecked"  @change="setTeacherChange($event, item)"></van-checkbox>
                                <img :src="item.avatar" />
                                <div class="person_info">
                                    <span class="name">
                                        {{ item.name }}
                                    </span>
                                    <span class="deptname">
                                        {{ item.deptName }}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <!-- 确认选择 -->
                <div class="change_list">
                    <span>已选择： </span>
                    <span class="number_span">
                        <span
                            v-if="(nowIsChangeDeptList.filter(item => item.children.length == 0).length + lastDeptList.filter(item => item.isChecked).length) > 0">{{
                                nowIsChangeDeptList.filter(item => item.children.length == 0).length + lastDeptList.filter(item => item.isChecked && isChildren(item.id)).length }} 个部门 </span>
                                    

                        <span v-if="(nowIsChangeList.length + lastPersonList.filter(item => item.isChecked).length) > 0">{{
                            nowIsChangeList.length + lastPersonList.filter(item => item.isChecked).length }} 位{{ personType
        == 'teacher' ? '老师' : '老师' }}</span>
                    </span>
                    <van-button type="info" size="small" @click="handleChange(1)">完成</van-button>
                </div>
            </div>


            <!-- 部门选择 -->
            <div class="department" v-if="tabActive == 2 && personType == 'teacher'">
                <div class="colleague_person_list">
                    <div class="list_con_con">

                        <!-- 班级选择弹窗 -->
                        <van-collapse v-model="activeNames" :border="false">

                            <!-- 外层 -->
                            <van-collapse-item :is-link="item.children && item.children.length > 0"
                                v-for="(item, index) in deptList" :key="item.id">
                                <template #title>
                                    <div class="list_con">
                                        <div @click.stop=""><van-checkbox v-model="item.isChecked"
                                                @change="test($event, item, index)"></van-checkbox></div>

                                        <img :src="schoolIcon" />
                                        <div class="person_info">
                                            <span class="name">
                                                {{ item.deptName }}
                                            </span>
                                            <span class="deptname">
                                                {{ item.classNumber }}人
                                            </span>
                                        </div>
                                    </div>
                                </template>

                                <!-- 内层1 -->
                                <template v-if="item.children.length">
                                    <van-collapse-item :is-link="item1.children && item1.children.length > 0"
                                        v-for="(item1, index1) in item.children" :key="item1.id">


                                        <template #title>
                                            <div class="list_con">
                                                <div @click.stop=""> <van-checkbox v-model="item1.isChecked"
                                                        @change="test($event, item1, index1)"></van-checkbox></div>

                                                <img :src="schoolIcon" />
                                                <div class="person_info">
                                                    <span class="name">
                                                        {{ item1.deptName }}
                                                    </span>
                                                    <span class="deptname">
                                                        {{ item1.classNumber }}人
                                                    </span>
                                                </div>
                                            </div>
                                        </template>

                                        <!-- 内层2 -->
                                        <template v-if="item1.children.length > 0">
                                            <van-collapse-item :is-link="item2.children && item2.children.length > 0"
                                                v-for="(item2, index2) in item1.children" :key="item2.id">
                                                <template #title>
                                                    <div class="list_con">
                                                        <div @click.stop="">
                                                            <van-checkbox v-model="item2.isChecked"
                                                                @change="test($event, item2, index2)"></van-checkbox>
                                                        </div>

                                                        <img :src="schoolIcon" />
                                                        <div class="person_info">
                                                            <span class="name">
                                                                {{ item2.deptName }}
                                                            </span>
                                                            <span class="deptname">
                                                                {{ item2.classNumber }}人
                                                            </span>
                                                        </div>
                                                    </div>
                                                </template>


                                                <!-- 内层3 -->
                                                <template v-if="item2.children.length > 0">
                                                    <van-collapse-item
                                                        :is-link="item3.children && item3.children.length > 0"
                                                        v-for="(item3, index3) in item2.children" :key="item3.id">
                                                        <template #title>
                                                            <div class="list_con">
                                                                <div @click.stop="">
                                                                    <van-checkbox v-model="item2.isChecked"
                                                                        @change="test($event, item3, index3)"></van-checkbox>
                                                                </div>

                                                                <img :src="schoolIcon" />
                                                                <div class="person_info">
                                                                    <span class="name">
                                                                        {{ item3.deptName }}
                                                                    </span>
                                                                    <span class="deptname">
                                                                        {{ item3.classNumber }}人
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <!-- 内层3 -->

                                                    </van-collapse-item>
                                                </template>
                                            </van-collapse-item>
                                        </template>
                                    </van-collapse-item>
                                </template>

                            </van-collapse-item>

                        </van-collapse>
                    </div>
                </div>
                <!-- 确认选择 -->
                <div class="change_list">
                    <span>已选择： </span>
                    <span class="number_span">
                        <span
                            v-if="(nowIsChangeDeptList.length + lastDeptList.filter(item => item.isChecked).length) > 0">{{
                                nowIsChangeDeptList.filter(item => item.children.length == 0).length + lastDeptList.filter(item => item.isChecked && isChildren(item.id)).length }} 个部门 </span>
                        <span v-if="(nowIsChangeList.length + lastPersonList.filter(item => item.isChecked).length) > 0">{{
                            nowIsChangeList.length + lastPersonList.filter(item => item.isChecked).length }} 位老师</span>
                    </span>
                    <van-button type="info" size="small" @click="handleChange(1)">完成</van-button>
                </div>
            </div>
        </div>

    </van-popup>
</template>

<script>

export default {
    props: ['leaveType', 'personType'],
    data() {
        return {
            // 弹窗显示隐藏
            showCcRequest: false,
            // 默认展示的tab栏序号
            tabActive: '0',
            // 部门背景图
            schoolIcon: require('@/assets/school_icon.png'),
            // 搜索的人员姓名
            personKerword: '',
            // 最近抄送的部门
            lastDeptList: [],
            // 最近抄送的员工
            lastPersonList: [],
            // 搜索老师结果
            teacherList: [],
            // 搜索部门结果
            deptList: [],
            // 已经选中的人员列表
            nowIsChangeList: [],
            // 当前选中的部门列表
            nowIsChangeDeptList: [],

            activeNames: ['1'],
            // 父级集合
            parentArr: [],
            resetIsChecked: true ,

            // 已选择列表
            nowSelectList: []



        }
    },
    watch: {
        'resetIsChecked': {
            handler(newVal, oldVal) {
                console.log(this.resetState)
                if (newVal) {
                    this.lastDeptList.forEach(item => item.isChecked = true)
                    this.lastPersonList.forEach(item => item.isChecked = true)
                } else {
                    this.lastDeptList.forEach(item => item.isChecked = false)
                    this.lastPersonList.forEach(item => item.isChecked = false)
                }
            }

        }
    },
    created() {
        // 获取上一次的抄送人数据
        this.getLastCcList()
        // 获取学校部门列表
        this.getSchoolDeptList()
    },
    methods: {
        // 获取抄送人信息
        async getLastCcList() {
            const { code, data } = await this.$https.getLastCcMakeList({
                leaveType: this.leaveType,
                schoolId: JSON.parse(localStorage.getItem('userInfo')).schoolId,
                userId: this.personType == 'teacher' ? JSON.parse(localStorage.getItem('userInfo')).id : this.$store.state.puserId
            })
            if (code == 200) {
                data.deptMakeList.forEach(item => {
                    item.deptName = item.name
                    item.isChecked = true
                })

                data.userMakeList.forEach(item => {
                    item.deptName = item.remark
                    item.isChecked = true
                })

                this.lastDeptList = data.deptMakeList
                this.lastPersonList = data.userMakeList

                // 初始化当前已选择的列表
                this.nowSelectList = data.userMakeList

            } else {
                this.$toast('获取最近抄送的部门或员工失败')
            }
        },


        // 获取学校部门列表
        async getSchoolDeptList() {
            const { code, data } = await this.$https.getDeptStaticsDataByschoolIdAndDate({
                schoolId: this.$store.state.schoolId,
                toDay: '2023-07-10'
            })
            if (data && data.length > 0 && code == 200) {
                let _this = this
                // 遍历部门 添加是否选中标识
                let arr = [] // 父级集合
                let lastArr = this.lastDeptList
                console.log('data-------------', data)
                function fn(data) {
                    data.forEach(item => {
                        // 判断是否在抄送历史当中
                        // console.log('判断是否在推送历史当中', _this.lastDeptList.find(dept => dept.id == item.id))
                        if (_this.lastDeptList.find(dept => dept.id == item.id)) {
                            item.isChecked = true
                        } else {
                            item.isChecked = false
                        }
                        if (item.children && item.children.length) {
                            arr.push(item.id)
                            fn(item.children)
                        }
                    })
                }

                // 判断是否全选
                function fnShow(data) {
                    data.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            item.isChecked = !item.children.filter(n => n.children.length == 0).some(s => s.isChecked == false)
                            fnShow(item.children)
                        }
                    })
                }

                fn(data)
                fnShow(data)
                this.deptList = data
                this.parentArr = arr
                // 给父级赋值


                // 组装数据 判断父即和子集
                this.lastDeptList.forEach(item => {
                    if (!this.isChildren(item.id)) {
                        item.children = [1, 1]
                    } else {
                        item.children = []
                    }
                })
                this.handleChange(0)
            } else {
                this.$toast('学校部门信息获取失败')
            }

        },

        onSearch() {
            this.getUserDept()
        },

        resetState(e) {
            console.log('e')
            // this.resetIsChecked = e
            this.lastDeptList.forEach(item => item.isChecked = false)
            this.lastPersonList.forEach(item => item.isChecked = false)
        },



        // 搜索部门 
        async getUserDept() {
            const { data, code } = await this.$https.getUserDept({
                name: this.personKerword,
                schoolId: this.$store.state.schoolId,
            })
            if (data && data.length > 0) {
                let arr = this.lastPersonList.filter(n => n.isChecked)

                let arr2 = this.nowIsChangeList
                // 和当前已选择的人员进行对比
                data.forEach(item => {
                    if (arr.find(n => n.id == item.id)) {
                        // item.isChecked = true
                        item.isShow = true
                    } else {
                        item.isChecked = false
                    }

                    if (arr2.find(s => s.id == item.id)) {
                        // item.isChecked = true
                        item.isShow = true
                    } else {
                        item.isChecked = false
                    }


                })
                this.teacherList = data
                console.log('this.nowIsChangeList', this.nowIsChangeList)
            } else {
                this.$toast('搜索不到当前人员，请检查后重试')
            }
        },



        // 设置老师选中
        setTeacherChange(e, data) {

            console.log('e',e)
            

            // 样式调整
            let obj = this.teacherList.find(x => x.id == data.id)
            obj.isShow = e



            // 判断选中人员
            if (e) {
                // 判断最近选中当中有无数据
                let a = this.lastPersonList.find(s => s.id == data.id)

                if (a) {
                    if (!a.isChecked) {
                        a.isChecked = true
                    }
                } else {
                    this.nowIsChangeList = [...this.nowIsChangeList, data]
                }

            } else {
                let a = this.lastPersonList.find(s => s.id == data.id)
                if (a) {
                    if (a.isChecked) {
                        a.isChecked = false
                    }
                } else {
                    this.nowIsChangeList = this.nowIsChangeList.filter(item => item.id != data.id)
                }


            }
        },


        // 取消老师选中
        cancelTeacherChange (e,data) {
            console.log('获取到选中信息和点击项',e,data)
            if (!e) {
                // 判断抄送人列表中有无
                let obj1 = this.nowIsChangeList.find(item => item.id == data.id)
                let obj2 = this.teacherList.find(item => item.id == data.id)

                console.log('obj1',obj1)
                console.log('obj2',obj2)


                if (obj1) {
                    this.nowIsChangeList =  this.nowIsChangeList.filter(s => s.id != data.id)
                }
                // // 判断人员列表中有无
                if (obj2) {
                    obj2.isShow = false
                }
            }
        },

        // 删除已选中的



        // 设置已选中老师
        setNowTeacherChange(e, data) {
            console.log('123456')
            if (e) {
                this.nowIsChangeList = [...this.nowIsChangeList, data]
            } else {
                this.nowIsChangeList = this.nowIsChangeList.filter(item => item.id != data.id)
            }
        },


        // 部门选择 
        test(e, data) {
            // 判断添加或者删除抄送部门
            if (e) { // e == true

                // 当前选中的部门列表
                let newDeptList = this.nowIsChangeDeptList
                // 部门列表
                let deptList = this.deptList
                // 最近选中的部门
                let lastDeptList = JSON.parse(JSON.stringify(this.lastDeptList))

                // 更新显示状态 
                const setDeptState = (obj2) => {
                    obj2.forEach(item => {
                        item.isChecked = true
                        if (item.children && item.children.length > 0) {
                            setDeptState(item.children)
                        }
                    })
                }



                function fn1(obj) {
                    obj.forEach(item => {
                        if (item.id == data.id) {
                            // 改变相关状态
                            item.isChecked = true
                            setDeptState(item.children)
                        } else {
                            if (item.children && item.children.length > 0) {
                                fn1(item.children)
                            }

                        }
                    })
                }


                fn1(deptList)


                // 更新数据

                // 上一次存在当前部门 优先处理上一次的数据
                if (data.children && data.children.length > 0) {
                    function fn(data) {
                        // 判断最近中有无该部门
                        if (lastDeptList.some(n => n.id == data.id)) {
                            lastDeptList.find(s => s.id == data.id).isChecked = true
                        } else {
                            if (!newDeptList.some(x => x.id == data.id)) {
                                newDeptList.push(data)
                            }
                        }




                        data.children.forEach(item => {
                            if (item.children && item.children.length) {
                                if (lastDeptList.some(n => n.id == item.id)) {
                                    lastDeptList.find(s => s.id == item.id).isChecked = true
                                } else {
                                    if (!newDeptList.some(x => x.id == item.id)) {
                                        newDeptList.push(item)
                                    }
                                }
                                fn(item)
                            } else {
                                // 判断最近抄送的部门中是否存在当前部门
                                if (lastDeptList.some(n => n.id == item.id)) {
                                    lastDeptList.find(s => s.id == item.id).isChecked = true
                                } else {
                                    if (!newDeptList.some(x => x.id == item.id)) {
                                        newDeptList.push(item)
                                    }
                                }
                            }
                        })
                    }
                    fn(data)
                } else {

                    if (lastDeptList.some(n => n.id == data.id)) {
                        lastDeptList.find(s => s.id == data.id).isChecked = true
                    } else {
                        if (!newDeptList.some(x => x.id == data.id)) {
                            newDeptList.push(data)
                        }
                    }

                }

                this.nowIsChangeDeptList = newDeptList
                this.lastDeptList = lastDeptList
                // console.log('nowIsChangeDeptList,lastDeptList2',this.nowIsChangeDeptList,this.lastDeptList)

            } else { // e == false

                // 更新显示状态
                let newDeptList = this.nowIsChangeDeptList // 选择的部门列表
                let deptList = this.deptList
                let lastDeptList = JSON.parse(JSON.stringify(this.lastDeptList))

                // 更新显示状态 
                const setDeptNotState = (obj2) => {
                    obj2.forEach(item => {
                        item.isChecked = false
                        if (item.children && item.children.length > 0) {
                            setDeptNotState(item.children)
                        }
                    })
                }

                function fn2(obj) {
                    obj.forEach(item => {
                        if (item.id == data.id) {
                            // 改变相关状态
                            item.isChecked = false
                            setDeptNotState(item.children)
                        } else {
                            if (item.children && item.children.length > 0) {
                                fn2(item.children)
                            }

                        }
                    })
                }
                fn2(deptList)


                // 更新数据 


                // 上一次存在当前部门 优先处理上一次的数据
                if (data.children && data.children.length > 0) {

                    function fn3(data) {
                        if (lastDeptList.some(n => n.id == data.id)) {
                            lastDeptList.find(s => s.id == data.id).isChecked = false
                        } else {
                            newDeptList = newDeptList.filter(n => n.id != data.id)
                        }
                        data.children.forEach(item => {
                            if (item.children && item.children.length) {
                                if (lastDeptList.some(n => n.id == item.id)) {
                                    lastDeptList.find(s => s.id == item.id).isChecked = false
                                } else {
                                    newDeptList = newDeptList.filter(n => n.id != item.id)
                                }
                                fn3(item)
                            } else {
                                if (lastDeptList.some(n => n.id == item.id)) {
                                    lastDeptList.find(s => s.id == item.id).isChecked = false
                                } else {
                                    newDeptList = newDeptList.filter(n => n.id != item.id)
                                }

                            }
                        })
                    }
                    fn3(data)
                } else {
                    // 判断当前抄送部门
                    if (lastDeptList.some(n => n.id == data.id)) {
                        lastDeptList.find(s => s.id == data.id).isChecked = false
                    } else {
                        newDeptList = newDeptList.filter(n => n.id != data.id)
                    }
                }


                this.nowIsChangeDeptList = newDeptList
                this.lastDeptList = lastDeptList
            }

            console.log('nowIsChangeDeptList,lastDeptList1-----------', this.nowIsChangeDeptList, this.lastDeptList)


        },


        // 抄送部门历史
        testDept(e, data) {
            let parentId = data.parentId
            // 判断传递父级数据
            while (this.lastDeptList.find(item => item.id == parentId)) {
                let parentObj = this.lastDeptList.find(item => item.id == parentId)
                if (parentObj) {
                    let children = this.lastDeptList.filter(item => item.parentId == parentId)
                    parentObj.isChecked = !children.some(item => item.isChecked == false)
                    parentId = parentObj.parentId
                }

            }

            // 样式同步
            const fn = (obj) => {
                obj.forEach(item => {
                    if (item.id == data.id) {
                        // 改变相关状态
                        item.isChecked = e
                    } else {
                        if (item.children && item.children.length > 0) {
                            fn(item.children)
                        }

                    }
                })
            }
            fn(this.deptList)

            // 刷新全选和未选
            const fnShow = (data) => {
                data.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        if (!item.children.filter(n => n.children.length == 0).some(s => s.isChecked == true)) {
                            item.isChecked = false
                        } else if (!item.children.filter(n => n.children.length == 0).some(s => s.isChecked == false)) {
                            item.isChecked = true
                        }
                        fnShow(item.children)
                    }
                })
            }
            fnShow(this.deptList)
        },


        // 判断当前是否是子集
        isChildren(id) {
            return !this.parentArr.includes(id)
        },


        // 返回选中的部门和人员
        handleChange(state = 1) {
            console.log('数据', [...this.nowIsChangeDeptList, ...this.lastDeptList.filter(item => item.isChecked)])
            // return 
            this.$emit('selectItem', {
                makeUserList: [...this.nowIsChangeList, ...this.lastPersonList.filter(item => item.isChecked)],
                makeDeptList: [...this.nowIsChangeDeptList, ...this.lastDeptList.filter(item => item.isChecked)],
                state
            })
        }

    }
}
</script>
<style lang="scss" >
.cc {
    height: 100%;
    display: flex;
    flex-direction: column;


    .recently {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;

        .colleague_person_list {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            position: relative;

            .list_con_con {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

                .list_con {
                    padding: 0 1.1111rem;
                    display: flex;
                    align-items: center;

                    img {
                        width: 2.8462rem;
                        height: 2.8462rem;
                        border-radius: 50%;
                        margin-left: 12px;
                    }

                    .person_info {
                        display: flex;
                        // height: 3.8462rem;
                        flex: 1;
                        border-bottom: 1px solid #E5E5E5;
                        padding: .8rem 0;
                        margin-left: 1.1rem;
                        flex-direction: column;

                        .name {
                            font-size: 16px;
                            color: #191919;
                            margin-bottom: 5px;
                        }

                        .deptname {
                            font-size: 12px;
                            color: #A0A0A0;
                        }
                    }
                }
            }

        }

        .change_list {
            color: #1D89FA;
            display: flex;
            align-items: center;
            height: 3rem;
            justify-content: space-between;
            padding: 0 10px;

            .number_span {
                flex: 1;
                text-align: left;
            }
        }
    }

    // 老师
    .colleague {
        display: flex;
        flex: 1;
        // background-color: pink;
        flex-direction: column;
        justify-content: space-between;

        .colleague_search {
            border-top: 1px solid #E5E5E5;
            border-bottom: 1px solid #E5E5E5;
            height: 3.3rem;

            .search_btn {
                width: 3rem;
                text-align: center;
            }
        }

        .colleague_person_list {
            flex: 1;
            display: flex;
            position: relative;
            flex-direction: column;
            overflow-y: auto;

            .list_con_con {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            .list_con {
                padding: 0 1.1111rem;
                display: flex;
                align-items: center;

                .list_deptList {
                    display: flex;
                    align-items: center;
                }

                img {
                    width: 2.8462rem;
                    height: 2.8462rem;
                    border-radius: 50%;
                    margin-left: 12px;
                }

                .person_info {
                    display: flex;
                    // height: 3.8462rem;
                    flex: 1;
                    border-bottom: 1px solid #E5E5E5;
                    padding: .8rem 0;
                    margin-left: 1.1rem;
                    flex-direction: column;

                    .name {
                        font-size: 16px;
                        color: #191919;
                        margin-bottom: 5px;
                    }

                    .deptname {
                        font-size: 12px;
                        color: #A0A0A0;
                    }
                }
            }
        }

        .change_list {
            color: #1D89FA;
            display: flex;
            align-items: center;
            height: 3rem;
            justify-content: space-between;
            padding: 0 10px;

            .number_span {
                flex: 1;
                text-align: left;
            }
        }
    }

    //部门
    .department {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;

        .colleague_person_list {
            flex: 1;
            display: flex;
            position: relative;
            flex-direction: column;
            overflow-y: auto;

            .list_con_con {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

                .van-collapse {
                    .van-collapse-item {
                        .van-cell {
                            align-items: center !important;
                            padding: 0 1rem;
                        }

                        .van-collapse-item__wrapper {
                            .van-collapse-item__content {
                                padding: 0 1rem;
                            }
                        }
                    }

                }

                .list_con {
                    display: flex;
                    align-items: center;

                    img {
                        width: 2.8462rem;
                        height: 2.8462rem;
                        border-radius: 50%;
                        margin-left: 12px;
                    }

                    .person_info {
                        display: flex;
                        // height: 3.8462rem;
                        flex: 1;
                        // border-bottom: 1px solid #E5E5E5;
                        padding: .8rem 0;
                        margin-left: 1.1rem;
                        flex-direction: column;

                        .name {
                            font-size: 16px;
                            color: #191919;
                        }

                        .deptname {
                            font-size: 12px;
                            color: #A0A0A0;
                        }
                    }
                }
            }

        }

        .change_list {
            color: #1D89FA;
            display: flex;
            align-items: center;
            height: 3rem;
            justify-content: space-between;
            padding: 0 10px;

            .number_span {
                flex: 1;
                text-align: left;
            }
        }
    }
}

// 最近</style>